module.exports = __webpack_public_path__ + "img/wild.9841e49f.png";